import { all, call } from 'redux-saga/effects';
import { mainSagas } from "./main/main.sagas";

export function* rootSaga() {
	yield all([
		call(mainSagas),
	])
}